import apiHeader from '@/helpers/apiHeader';

const smartcatAttachmentService = {
  listAll(params) {
    return apiHeader.get('dictionary/smartcat-attachment', { params });
  },
  detailFolder(id, params) {
    return apiHeader.get('dictionary/smartcat-attachment/folder/' + id, { params });
  },
  countSizeFolder(id) {
    return apiHeader.get('dictionary/smartcat-attachment/folder/size/' + id);
  },
  createFolder(params) {
    return apiHeader.post('dictionary/smartcat-attachment/folder', params);
  },
  renameFolder(id, params) {
    return apiHeader.patch('dictionary/smartcat-attachment/folder/' + id, params);
  },
  deleteFolder(id) {
    return apiHeader.delete('dictionary/smartcat-attachment/folder/' + id);
  },
  moveFileOrFolder(id, params) {
    return apiHeader.post('dictionary/smartcat-attachment/move/' + id, params);
  },
  showFile(id) {
    return apiHeader.get('dictionary/smartcat-attachment/file/' + id, {
        responseType: 'blob'
    });
  },
  uploadFile(params, config = {}){
    return apiHeader.post('dictionary/smartcat-attachment/file', params, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        ...config
    });
  },
  saveLink(link, folderId = null) {
    const formData = new FormData();
    formData.append('type', 'link');
    formData.append('file', link);
    if (folderId) {
      formData.append('folder_attachment_id', folderId);
    }
    return apiHeader.post('dictionary/smartcat-attachment/file', formData);
  },
  renameFile(id, params) {
    return apiHeader.patch('dictionary/smartcat-attachment/file/' + id, params);
  },
  deleteFile(id) {
    return apiHeader.delete('dictionary/smartcat-attachment/file/' + id);
  },
  file(id) {
    return apiHeader.get(`dictionary/smartcat-attachment/file/${id}`, { responseType: 'blob' });
  },
  fileByCode(fileCode) {
    return apiHeader.get(`dictionary/smartcat-attachment/file/code/${fileCode}`, { responseType: 'blob' });
  },
};

export default smartcatAttachmentService;
